import React from "react";
import { Link } from "react-router-dom";

/**
 * Mandatory consent checkbox shown above every inquiry CTA.
 * Wording per TRAI/DND compliance — explicit opt-in to Email/SMS/WhatsApp/Call overrides DND.
 */
export default function ConsentCheckbox({ checked, onChange, testId = "inq-consent" }) {
  return (
    <label
      className="flex items-start gap-2.5 mt-4 cursor-pointer select-none"
      data-testid={`${testId}-label`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
        required
        className="mt-0.5 w-4 h-4 accent-[#D4A437] shrink-0"
      />
      <span className="text-[11px] leading-relaxed text-slate-600">
        I authorise <strong className="text-slate-800">OC Infraventures</strong> &amp; its
        representatives to contact me with updates and notifications via Email / SMS /
        WhatsApp / Call. This will override DND / NDNC. See our{" "}
        <Link
          to="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#B88C2E] underline decoration-dotted hover:text-[#D4A437]"
          data-testid={`${testId}-privacy-link`}
        >
          Privacy Policy
        </Link>.
      </span>
    </label>
  );
}
